// @ts-check
/** @jsxRuntime classic */
/** @jsx jsx */
import { gql } from '@apollo/client';
import { Section } from '@bottlebooks/gatsby-design-system';
import { Trans } from '@lingui/macro';
import { graphql } from 'gatsby';
import { jsx } from 'theme-ui';
import VarietiesText from './VarietiesText';

export default function Varieties({ wine, icon = null, ...rest }) {
  return (
    <Section title={<Trans>Varieties</Trans>} {...rest}>
      <VarietiesText variant="default" wine={wine} icon={icon} />
    </Section>
  );
}

export const fragment = graphql`
  fragment Varieties on Wine {
    ...VarietiesText
  }
`;

Varieties.fragment = gql`
  fragment Varieties on Wine {
    ...VarietiesText
  }
  ${VarietiesText.fragment}
`;
